var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisible = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7.33647C8.97667 7.33647 7.33641 8.97673 7.33641 11.0001C7.33641 13.0234 8.97667 14.6637 11 14.6637C13.0234 14.6637 14.6636 13.0234 14.6636 11.0001C14.6636 8.97673 13.0234 7.33647 11 7.33647ZM6.41364 11.0001C6.41364 8.46709 8.46703 6.4137 11 6.4137C13.533 6.4137 15.5864 8.46709 15.5864 11.0001C15.5864 13.5331 13.533 15.5865 11 15.5865C8.46703 15.5865 6.41364 13.5331 6.41364 11.0001Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.395113 10.7626C2.80044 6.75761 6.63543 4.12207 11 4.12207C15.3646 4.12207 19.1996 6.75761 21.6049 10.7626L21.7476 11.0001L21.6049 11.2377C19.1996 15.2426 15.3646 17.8782 11 17.8782C6.63543 17.8782 2.80044 15.2426 0.395113 11.2377L0.252441 11.0001L0.395113 10.7626ZM1.33167 11.0001C3.61739 14.6603 7.11773 16.9554 11 16.9554C14.8823 16.9554 18.3827 14.6603 20.6684 11.0001C18.3827 7.33994 14.8823 5.04485 11 5.04485C7.11773 5.04485 3.61739 7.33994 1.33167 11.0001Z",
    fill: "#B41730"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisible);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visible.c0b8093fbbe72f29bbe5c11f405e225a.svg";